import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})
export class ReportComponent {
  title = 'Reports';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  navigate(url: string) {
    this.router.navigate([url], { relativeTo: this.route.parent });
  }
}
